export const isWeekend = ()=> {
  const today = new Date();
  const dayOfWeek = today.getDay();
  
  // getDay() returns 0 for Sunday and 6 for Saturday
  return dayOfWeek === 0 || dayOfWeek === 6;
}